import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';

@Service()
export class TranslocoHttpLoader implements TranslocoLoader {
    private readonly _http = new HttpClient(inject(HttpBackend));

    getTranslation(lang: string): Observable<Translation> {
        return this._http.get<Translation>(`../assets/i18n/${lang}.json?_${Date.now()}`);
    }
}
